export const COPYRIGHT_DATA_TEST_ID = 'copyright-info';
